import { Component, OnInit } from '@angular/core';
import { MDBModalRef } from 'angular-bootstrap-md';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-popup-without-confirm',
  templateUrl: './popup-without-confirm.component.html',
  styleUrls: ['./popup-without-confirm.component.scss']
})
export class PopupWithoutConfirmComponent implements OnInit {

 action = new Subject();
message: string;
title: string;

constructor(public modalRef: MDBModalRef) {}

ngOnInit() {

  if (this.modalRef && this.modalRef.content && this.modalRef.content.data) {

    this.title = this.modalRef.content.data.title;
    this.message = this.modalRef.content.data.message;

  }

}

close() {
  this.action.next('OK');
  this.modalRef.hide();
}

}
